<div class="collection-container">
    @for (item of inputValue; track trackByIndex(i, item); let i = $index) {
        <div [@fadeIn]="!!item.__created" [class.dim]="fade === i" class="collection-rows mb-2">
            <form #itemForm="ngForm" ngForm class="position-absolute invisible">
                <sf-form
                    [view]="$any(view.children)[i] || view?.vars?.prototype"
                    name="value"
                    [(ngModel)]="inputValue[i]"
                    [renderAll]="true"
                    (ngModelChange)="onInputChange()"
                    [horizontal]="false"
                ></sf-form>
            </form>
            <div class="d-flex align-items-center">
                @if (inputValue[i]?.filename) {
                    <div class="d-flex align-items-center flex-grow-1">
                        <ngxh6-fileicon class="me-2" [small]="true" [file]="inputValue[i]"></ngxh6-fileicon>
                        <a class="flex-grow-1" target="_blank" [href]="inputValue[i].path">{{ inputValue[i].originalFilename }}</a>
                        <small class="ms-1 text-muted flex-shrink-0 text-nowrap ms-sm-auto">{{ +inputValue[i].size | bytes: 1 }}</small>
                    </div>
                }
                <div class="collection-remove-wrapper ms-auto">
                    @if (view?.vars?.allow_delete) {
                        <button type="button" class="btn ms-2 btn-danger collection-remove" (click)="removeItem(i)" (mouseover)="fade = i" (mouseleave)="fade = null">
                            <i class="fa fa-trash"></i>
                        </button>
                    }
                </div>
            </div>
        </div>
    }
</div>

@if (view?.vars?.allow_add) {
    <div class="d-flex">
        <div class="dz-container">
            <dropzone
                #drpzone
                class="btn-lg btn btn-outline-primary"
                [useDropzoneClass]="false"
                [message]="'Drop files or click here to upload'"
                (uploadProgress)="onUploadProgress($event)"
                (error)="onUploadError($event)"
                (addedFile)="onAddedFile($event)"
                (sending)="onSending($event)"
                (success)="onUploadSuccess($event)"
                [config]="DROPZONE_CONFIG"
            >
            </dropzone>
            @if (uploading > 0) {
                <div class="progress mt-2">
                    <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [ngStyle]="{ width: uploadProgress + '%' }"></div>
                </div>
                <div class="d-flex mt-1 align-items-center">
                    <small>Uploading {{ uploading }} {{ 'file' | makePluralString: uploading }}. {{ this.bytesDownloaded | bytes: 1 }}/{{ this.bytesTotal | bytes: 1 }}</small>
                    <div class="btn btn-sm btn-danger ms-auto" (click)="cancelUpload()">Cancel</div>
                </div>
            }
        </div>
    </div>
}
